export default __webpack_public_path__ + "static/media/app_logo.6bdd2bf4.png";